import { useState, useEffect } from 'react';
import {
    collection,
    query,
    onSnapshot,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    serverTimestamp,
    orderBy,
    setDoc
} from 'firebase/firestore';
import { db } from '../firebase';

export const usePlays = (playbookId) => {
    const [plays, setPlays] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!playbookId || playbookId === 'local') {
            setPlays({});
            setLoading(false);
            return;
        }

        const q = query(
            collection(db, 'playbooks', playbookId, 'plays'),
            orderBy('order', 'asc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const playsObj = {};
            snapshot.docs.forEach(doc => {
                playsObj[doc.id] = { id: doc.id, ...doc.data() };
            });
            setPlays(playsObj);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching plays:", error);
            setLoading(false);
        });

        return unsubscribe;
    }, [playbookId]);

    const savePlay = async (playId, playData, userInfo = {}) => {
        if (!playbookId || playbookId === 'local') return;

        const { uid, email, displayName } = userInfo;

        // If playId is provided, update existing. If not, create new.
        if (playId) {
            const playRef = doc(db, 'playbooks', playbookId, 'plays', playId);
            return await updateDoc(playRef, {
                ...playData,
                updatedAt: serverTimestamp(),
                updatedBy: uid || null,
                updatedByName: displayName || email || 'Unknown'
            });
        } else {
            const playRef = doc(collection(db, 'playbooks', playbookId, 'plays'));
            return await setDoc(playRef, {
                ...playData,
                id: playRef.id,
                playbookId,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
                createdBy: uid || null,
                createdByName: displayName || email || 'Unknown',
                updatedBy: uid || null,
                updatedByName: displayName || email || 'Unknown'
            });
        }
    };

    const deletePlay = async (playId) => {
        if (!playbookId || playbookId === 'local') return;
        return await deleteDoc(doc(db, 'playbooks', playbookId, 'plays', playId));
    };

    return { plays, loading, savePlay, deletePlay };
};
